var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _path9, _path0, _path1, _path10, _g4, _path11, _g5, _path12, _path13, _path14, _path15, _g6, _path16, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoofcleaning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_18996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 10,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.4011H9.31263V40.7342H0V15.4011Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_18996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59874 40.6562H1.22363V16.0835L8.59874 25.9167V40.6562Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2566 40.6562V28.3698L8.6001 25.9167V40.6562H28.2566Z",
    fill: "#888DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.085 8.2916L42.033 1.34375L45.507 4.81767L38.559 11.7655L35.085 8.2916Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4295 12.6352L34.2159 7.42175L31.6064 11.7655L35.0857 15.2446L39.4295 12.6352Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0854 15.2445L30.7155 28.3486L18.6528 16.083L31.6061 11.7654L35.0854 15.2445Z",
    fill: "#29ABE2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_18996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 32,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.4011H31.9796V28.7343H0V15.4011Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_18996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22363 16.0835H20.8854L30.7136 28.3698H11.0571L1.22363 16.0835Z",
    fill: "#29ABE2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_18996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 32,
    height: 17
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0671H31.9796V30.067H0V14.0671Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_18996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.120422 15.552C0.323549 15.1301 0.755847 14.8593 1.2246 14.8593H20.8863C21.2561 14.8593 21.6103 15.0259 21.8447 15.3176L31.673 27.6039C31.9646 27.9737 32.0271 28.4789 31.8188 28.906C31.6157 29.3279 31.1834 29.5987 30.7146 29.5987H11.0581C10.6831 29.5987 10.3289 29.432 10.0945 29.1404L0.266257 16.854C-0.0254136 16.4842 -0.0827065 15.979 0.120422 15.552ZM3.78193 17.3124L11.6466 27.1404H28.1573L20.2926 17.3124H3.78193Z",
    fill: "#9BC9FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14111 21H25.7976V23.4583H6.14111V21Z",
    fill: "#9BC9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55683 15.3176L19.3851 27.604L17.4684 29.1404L7.64014 16.8541L9.55683 15.3176Z",
    fill: "#9BC9FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7412 33.286V40.6557H23.3403V33.286H14.7412Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6979 15.3176L25.5262 27.604L23.6095 29.1404L13.7812 16.8541L15.6979 15.3176Z",
    fill: "#9BC9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_18996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 23,
    width: 25,
    height: 19
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64648 23.4008H30.6468V41.9995H6.64648V23.4008Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_18996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60125 24.6871C9.27835 24.6871 9.83044 25.234 9.83044 25.9163V39.4266H27.0286V28.3694C27.0286 27.6923 27.5807 27.1402 28.2578 27.1402C28.9349 27.1402 29.487 27.6923 29.487 28.3694V40.6557C29.487 41.3328 28.9349 41.8849 28.2578 41.8849H8.60125C7.91895 41.8849 7.37207 41.3328 7.37207 40.6557V25.9163C7.37207 25.234 7.91895 24.6871 8.60125 24.6871Z",
    fill: "#9BC9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_18996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 0,
    width: 14,
    height: 15
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.311 0H46.9987V14.0676H33.311V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_18996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9 0.47363C43.3792 0.952791 43.3792 1.73403 42.9 2.2132L35.9468 9.16105C35.4676 9.64021 34.6916 9.64021 34.2124 9.16105C33.7332 8.68189 33.7332 7.90585 34.2124 7.42148L41.1604 0.47363C41.6396 -0.00553301 42.4209 -0.00553301 42.9 0.47363ZM46.374 3.94755C46.8532 4.42672 46.8532 5.20796 46.374 5.68712L39.426 12.635C38.9416 13.1141 38.1656 13.1141 37.6864 12.635C37.2072 12.1558 37.2072 11.3798 37.6864 10.9006L44.6344 3.94755C45.1136 3.46839 45.8949 3.46839 46.374 3.94755Z",
    fill: "#9BC9FF"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0639 6.203C34.4389 6.15612 34.8139 6.28633 35.0848 6.55716L40.2932 11.7654C40.564 12.0363 40.6942 12.4113 40.6474 12.7863C40.6005 13.1613 40.3817 13.4946 40.0588 13.6925L35.715 16.2966C35.2306 16.5883 34.6108 16.5102 34.215 16.1091L30.741 12.6352C30.3399 12.2394 30.2618 11.6196 30.5535 11.1352L33.1577 6.79153C33.3556 6.46862 33.6889 6.24987 34.0639 6.203ZM34.4598 9.40609L33.1525 11.5779L35.2723 13.6977L37.4442 12.3904L34.4598 9.40609Z",
    fill: "#9BC9FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7718 11.3803C32.9853 12.0209 32.6416 12.7188 31.9957 12.9323L19.0424 17.25C18.3966 17.4635 17.7039 17.1198 17.4851 16.474C17.2716 15.8281 17.6205 15.1354 18.2664 14.9219L31.2197 10.6042C31.8603 10.3855 32.5582 10.7344 32.7718 11.3803ZM35.4697 14.0782C36.1156 14.2917 36.4646 14.9896 36.2458 15.6302L31.8759 28.7395C31.6624 29.3801 30.9697 29.7291 30.3238 29.5155C29.678 29.302 29.3342 28.6041 29.5478 27.9634L33.9176 14.8542C34.1312 14.2084 34.8291 13.8646 35.4697 14.0782Z",
    fill: "#9BC9FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7419 16.1094C31.2211 16.5937 31.2211 17.3698 30.7419 17.8489L28.9034 19.6823C28.4242 20.1614 27.6481 20.1614 27.169 19.6823C26.6898 19.2031 26.6898 18.4271 27.169 17.9479L29.0023 16.1094C29.4815 15.6302 30.2575 15.6302 30.7419 16.1094Z",
    fill: "#9BC9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_18996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 39,
    width: 11,
    height: 3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.4008H10.646V41.9997H0V39.4008Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_18996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40.6557C0 39.9786 0.546882 39.4265 1.22398 39.4265H8.59908C9.27617 39.4265 9.82827 39.9786 9.82827 40.6557C9.82827 41.3327 9.27617 41.8848 8.59908 41.8848H1.22398C0.546882 41.8848 0 41.3327 0 40.6557Z",
    fill: "#9BC9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_18996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 31,
    width: 13,
    height: 11
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3135 31.4009H25.3137V41.9997H13.3135V31.4009Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_18996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5112 33.2863C13.5112 32.6092 14.0633 32.0571 14.7404 32.0571H23.3395C24.0218 32.0571 24.5687 32.6092 24.5687 33.2863V40.656C24.5687 41.3331 24.0218 41.8852 23.3395 41.8852C22.6624 41.8852 22.1103 41.3331 22.1103 40.656V34.5154H15.9696V40.656C15.9696 41.3331 15.4175 41.8852 14.7404 41.8852C14.0633 41.8852 13.5112 41.3331 13.5112 40.656V33.2863Z",
    fill: "#9BC9FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofcleaning);
export default __webpack_public_path__ + "static/media/Roof cleaning.24017118d5a28ab5513a6030090a654f.svg";
export { ForwardRef as ReactComponent };